import { css } from 'styled-components';
import token from 'styled-token';
import { iconSizeMixin } from '../iconSizeMixin';
import { spaceMixin } from '../spaceMixin';

/** @class ButtonIconMixin */
/** @method */
export var ButtonIconMixin = function ButtonIconMixin(props) {
  var iconPosition = props.iconPosition,
    iconSize = props.iconSize;
  return token('Button.icon.marginX', function (marginX) {
    return css(["margin-", ":", ";", ""], iconPosition === 'start' ? 'right' : 'left', marginX ? marginX + "px" : spaceMixin('xs')(props), iconSizeMixin(Object.assign({}, props, {
      iconSize: iconSize
    })));
  })(props);
};